import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { UrlContext } from '../utils';

/**
 * @param {import('../types/index.ts').Gig[]} gigs
 * @returns {import('../types/index.ts').Gig[]}
 */
export const useRelevantGigs = (gigs) =>
    useMemo(() => {
        /** @type {Pick<import('../utils/UrlContext/types').GigParam, 'id'|'slug'>[]} */
        const urlGigParams = UrlContext.getUrlGigs();
        const urlGigRefSlug = UrlContext.getRefGigSlug();
        if (urlGigRefSlug) {
            urlGigParams.push(urlGigRefSlug);
        }

        const gigsMap = keyBy(urlGigParams, (item) => item.id || item.slug);
        return gigs.filter((gig) => gigsMap[gig.gig_id] || gigsMap[gig.cached_slug]);
    }, [gigs]);
